import React, { useEffect, useState, useCallback } from 'react';
import { useFormik } from 'formik';
import { CommentOutlined } from '@ant-design/icons';
import { App } from 'antd';

import { PersonalBroadcastsModal } from './PersonalBroadcastsModal';
import { useTheme } from '../../../../../hooks/useTheme';
import { selectShopCurrent } from '../../../../shops/features/shops/store/shopSlice';
import { createFormData } from '../../../../../utils/common/createFormData';
import { initialValues } from '../utils/options';
import { PersonalBroadcastProps } from '../service/personal-broadcast.interface';
import { useApiErrorNotification } from '../../../../../hooks/useApiErrorNotification';
import { useCreatePersonaBroadcastMutation } from '../service/personal-broadcasts';
import { useAppSelector } from '../../../../../store';

export const PersonalBroadcastsCreateContainer = ({ item }) => {
    const { notification } = App.useApp();
    const { colorIcon, colorTextDisabled } = useTheme();

    const [isOpen, setIsOpen] = useState<boolean>(false);
    const current = useAppSelector(selectShopCurrent);

    const [createBroadcast, { isSuccess, isLoading, isError, error }] =
        useCreatePersonaBroadcastMutation();

    useApiErrorNotification(isError, error);

    useEffect(() => {
        if (isSuccess) {
            setIsOpen(false);
            notification.success({
                message: 'Готово',
                description: 'Сообщение отправлено',
            });
        }
    }, [isSuccess, notification]);

    const onSave = useCallback(
        (values: PersonalBroadcastProps) => {
            const data = {
                telegram_user_id: item.telegramUserId,
                ...values,
            };

            if (values.image === null) {
                delete data.image;
            }

            createBroadcast({ id: current.id, body: createFormData(data) });
        },
        [item.telegramUserId, current.id, createBroadcast]
    );

    const formik = useFormik({
        initialValues: initialValues,
        onSubmit: onSave,
    });

    const handleOpen = useCallback(() => {
        if (item.isAllowedPm) {
            setIsOpen(true);
        }
    }, [item.isAllowedPm]);

    return (
        <div>
            <CommentOutlined
                style={{
                    color: item.isAllowedPm ? colorIcon : colorTextDisabled,
                    fontSize: 20,
                    cursor: item.isAllowedPm ? 'pointer' : 'not-allowed',
                }}
                onClick={handleOpen}
            />
            {isOpen && (
                <PersonalBroadcastsModal
                    onSave={onSave}
                    formik={formik}
                    isOpen={isOpen}
                    setIsOpen={setIsOpen}
                    isLoading={isLoading}
                />
            )}
        </div>
    );
};
